/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { React } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { Icon, Table, Button, Checkbox, Message, Header } from 'semantic-ui-react';

const ClientDashboard = ({ complaintData }) => {
  const userFirstname = localStorage.getItem('userFirstname');
  const userLastname = localStorage.getItem('userLastname');
  return (
    <>
      <Message>
        <Header as="h2" color="blue">
          <Icon name="settings" />
          <Header.Content>
            Mes plaintes
            <Header.Subheader>
              {userFirstname} {userLastname}
            </Header.Subheader>
          </Header.Content>
        </Header>
      </Message>
      <Table celled compact definition color="blue" key="blue">
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell>Statut</Table.HeaderCell>
            <Table.HeaderCell>Prenom</Table.HeaderCell>
            <Table.HeaderCell>Nom</Table.HeaderCell>
            <Table.HeaderCell>E-mail</Table.HeaderCell>
            <Table.HeaderCell>Type de la plainte</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {complaintData &&
            complaintData.complaintByCognitoId &&
            complaintData.complaintByCognitoId.items.map((data) => (
              <Table.Row key={data.confirmation}>
                <Table.Cell collapsing>
                  <Checkbox slider />
                </Table.Cell>
                <Table.Cell>{data.statut}</Table.Cell>
                <Table.Cell>{data.firstname}</Table.Cell>
                <Table.Cell>{data.lastname}</Table.Cell>
                <Table.Cell>{data.email}</Table.Cell>
                <Table.Cell>{data.complaintType}</Table.Cell>

                <Table.Cell>
                  <Button
                    className="ui basic button"
                    as={NavLink}
                    to={`/complaint-view/${data.confirmation}`}
                  >
                    <i className="blue icon content"> </i>
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell />
            <Table.HeaderCell colSpan="7">
              <Button
                floated="right"
                icon
                labelPosition="left"
                as={Link}
                to="/complaint-client"
                positive
                size="small"
              >
                <Icon name="add" /> Ajouter une plainte
              </Button>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};

export default ClientDashboard;
